import { useTranslate } from '@i18n';
import { Button, Inline, Modal, Text, u } from '@ui';

type HandednessConfirmationModalProps = {
    onConfirm: () => void;
    onDismiss: () => void;
};

export const HandednessConfirmationModal = ({ onConfirm, onDismiss }: HandednessConfirmationModalProps) => {
    const t = useTranslate();

    return (
        <Modal
            title={t('user_settings.handedness_change_title')}
            open
            variant="partial"
            onDismiss={onDismiss}
            footer={{
                primary: (
                    <Inline justifyContent="flex-end" gap={u(2)}>
                        <Button variant="primary" onClick={onConfirm}>
                            {t('user_settings.handedness_change_confirm')}
                        </Button>
                    </Inline>
                ),
                secondary: (
                    <Button variant="secondary" onClick={onDismiss}>
                        {t('generic_ui.cancel')}
                    </Button>
                ),
            }}
        >
            <Text variant="p">{t('user_settings.handedness_change_message')}</Text>
        </Modal>
    );
};
